<div class="container u-mt60">
    <div class="row">
        <div class="col-12">
            <div class="breadcrumbs">
                <ul>
                    <li>
                        <a href="">
                            Inicio
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-md-7">
            <h1 class="txt txt--title">Preguntas frecuentes</h1>
            <small>Ingresa a la categoría donde buscas la información.</small>
        </div>
        <div class="col-md-5">
            <div class="form autocomplete autocomplete--small u-mb20">
                <input type="text" id="iexample" class="form__search" placeholder="Buscar pregunta frecuente">
            </div>
        </div>
    </div>
</div>

<div class="admin">
    <div class="container">
        <div class="row">
            <div class="admin__actions col-12">
                <div class="row">
                    <div class="col-12 col-lg-4">
                        <div class="admin__action">
                            <h3>Requisitos</h3>
                            <p>
                                Listado de requisitos asociados a zonas, equipos o al conductor.
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div class="admin__action">
                            <h3>Solicitudes</h3>
                            <p>
                                Tipos de solicitudes, tiempos e información.
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div class="admin__action">
                            <h3>Equipos</h3>
                            <p>
                                Listado de equipos disponibles a conducir u operar.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-4">
                        <div class="admin__action">
                            <h3>Infracciones</h3>
                            <p>
                                Tipos de infracciones y sanciones correspondientes.
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div class="admin__action">
                            <h3>Licencias</h3>
                            <p>
                                Clases de licencias y sus autorizaciones.
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div class="admin__action">
                            <h3>Reglamento interno</h3>
                            <p>
                                Documento con el código de conducta para licencias.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
